<template>
  <div class="theMasses">
    <div class="left">
      <div class="text1">
        Servicios de préstamo profesionales, elegidos por más de
        <span>500,000</span> usuarios
      </div>
      <div class="text2">
        Cualquier persona mayor de 18 años puede solicitar un préstamo, con
        servicio 24/7 todo el año. Cada vez más usuarios confían en nosotros.
      </div>
    </div>
    <img src="@/assets/35919@2x.png" class="right" />
  </div>
</template>

<script>
export default {
  name: "theMasses",
  data() {
    return {};
  },

  computed: {},

  mounted() {},

  methods: {},
};
</script>
<style scoped lang="scss">
@media (min-width: 680px) {
  .theMasses {
    max-width: 1080px;
    padding: 100px 0;
    margin: 0 auto;
    display: flex;
    justify-content: center;
    align-items: center;
    .left {
      width: 420px;
      margin-right: 80px;
      .text1 {
        font-weight: bold;
        font-size: 30px;
        color: #3d3d3d;
        line-height: 41px;
        text-align: left;
        span {
          color: #834ffd;
        }
      }
      .text2 {
        margin-top: 18px;
        font-weight: 500;
        font-size: 14px;
        color: #6b6b6b;
        line-height: 21px;
        text-align: left;
      }
    }
    .right {
      width: 360px;
    }
  }
}

@media only screen and (max-width: 680px) {
  .theMasses {
  
    padding: 60px 30px;
    margin: 0 auto;
    display: flex;
    justify-content: center;
    align-items: center;
    .left {
      margin-right: 30px;
      .text1 {
        font-weight: bold;
        font-size: 22px;
        color: #3d3d3d;
        line-height: 41px;
        text-align: left;
        span {
          color: #834ffd;
        }
      }
      .text2 {
        margin-top: 18px;
        font-weight: 500;
        font-size: 12px;
        color: #6b6b6b;
        line-height: 21px;
        text-align: left;
      }
    }
    .right {
      width: 180px;
    }
  }
}
</style>
